import API_BASE_URL from '../config/api';
const USE_REAL_API = true;

const authHeaders = () => {
  const token =
    typeof localStorage !== 'undefined' ? localStorage.getItem('token') : null;
  return token ? { Authorization: `Bearer ${token}` } : {};
};

// Mock data for development
const mockCustomers = [
  {
    id: 1,
    firstName: 'John',
    lastName: 'Doe',
    email: 'john.doe@example.com',
    phone: '+1 (555) 123-4567',
    company: 'ABC Construction',
    address: {
      street: '123 Main Street',
      city: 'New York',
      state: 'NY',
      zipCode: '10001',
      country: 'USA',
    },
    status: 'active',
    customerType: 'business',
    registrationDate: '2024-01-15T10:30:00Z',
    lastOrderDate: '2024-01-20T14:20:00Z',
    totalOrders: 12,
    totalSpent: 2450.75,
    notes: 'Regular customer, prefers bulk orders',
    tags: ['construction', 'bulk-buyer', 'reliable'],
    preferences: {
      communication: 'email',
      currency: 'USD',
      language: 'en',
    },
  },
  {
    id: 2,
    firstName: 'Sarah',
    lastName: 'Johnson',
    email: 'sarah.j@example.com',
    phone: '+1 (555) 987-6543',
    company: 'Johnson & Associates',
    address: {
      street: '456 Oak Avenue',
      city: 'Los Angeles',
      state: 'CA',
      zipCode: '90210',
      country: 'USA',
    },
    status: 'active',
    customerType: 'business',
    registrationDate: '2024-01-10T09:15:00Z',
    lastOrderDate: '2024-01-18T11:45:00Z',
    totalOrders: 8,
    totalSpent: 1890.5,
    notes: 'Interested in workwear products',
    tags: ['workwear', 'professional', 'new-customer'],
    preferences: {
      communication: 'phone',
      currency: 'USD',
      language: 'en',
    },
  },
  {
    id: 3,
    firstName: 'Mike',
    lastName: 'Wilson',
    email: 'mike.wilson@email.com',
    phone: '+1 (555) 456-7890',
    company: null,
    address: {
      street: '789 Pine Street',
      city: 'Chicago',
      state: 'IL',
      zipCode: '60601',
      country: 'USA',
    },
    status: 'inactive',
    customerType: 'individual',
    registrationDate: '2023-12-05T16:20:00Z',
    lastOrderDate: '2023-12-15T10:30:00Z',
    totalOrders: 3,
    totalSpent: 450.25,
    notes: "One-time customer, hasn't ordered recently",
    tags: ['individual', 'one-time', 'inactive'],
    preferences: {
      communication: 'email',
      currency: 'USD',
      language: 'en',
    },
  },
  {
    id: 4,
    firstName: 'Emily',
    lastName: 'Brown',
    email: 'emily.brown@company.com',
    phone: '+1 (555) 321-0987',
    company: 'Brown Industries',
    address: {
      street: '321 Elm Street',
      city: 'Houston',
      state: 'TX',
      zipCode: '77001',
      country: 'USA',
    },
    status: 'active',
    customerType: 'business',
    registrationDate: '2024-01-08T14:45:00Z',
    lastOrderDate: '2024-01-22T09:15:00Z',
    totalOrders: 15,
    totalSpent: 3200.0,
    notes: 'VIP customer, high volume orders',
    tags: ['vip', 'high-volume', 'paints', 'loyal'],
    preferences: {
      communication: 'email',
      currency: 'USD',
      language: 'en',
    },
  },
  {
    id: 5,
    firstName: 'David',
    lastName: 'Lee',
    email: 'david.lee@contractor.com',
    phone: '+1 (555) 654-3210',
    company: 'Lee Contracting',
    address: {
      street: '654 Maple Drive',
      city: 'Phoenix',
      state: 'AZ',
      zipCode: '85001',
      country: 'USA',
    },
    status: 'active',
    customerType: 'business',
    registrationDate: '2024-01-12T11:30:00Z',
    lastOrderDate: '2024-01-21T16:45:00Z',
    totalOrders: 6,
    totalSpent: 1200.75,
    notes: 'Prefers workwear and safety equipment',
    tags: ['contractor', 'safety', 'workwear', 'regular'],
    preferences: {
      communication: 'phone',
      currency: 'USD',
      language: 'en',
    },
  },
];

// Generate additional customers to reach 50+
const generateAdditionalCustomers = () => {
  const additionalCustomers = [];
  let id = 6;

  const firstNames = [
    'Alex',
    'Maria',
    'James',
    'Lisa',
    'Robert',
    'Jennifer',
    'Michael',
    'Linda',
    'William',
    'Patricia',
    'Richard',
    'Barbara',
    'Joseph',
    'Elizabeth',
    'Thomas',
    'Jennifer',
    'Christopher',
    'Maria',
    'Charles',
    'Susan',
    'Daniel',
    'Karen',
    'Matthew',
    'Nancy',
    'Anthony',
    'Betty',
    'Mark',
    'Helen',
    'Donald',
    'Sandra',
  ];

  const lastNames = [
    'Smith',
    'Johnson',
    'Williams',
    'Brown',
    'Jones',
    'Garcia',
    'Miller',
    'Davis',
    'Rodriguez',
    'Martinez',
    'Hernandez',
    'Lopez',
    'Gonzalez',
    'Wilson',
    'Anderson',
    'Thomas',
    'Taylor',
    'Moore',
    'Jackson',
    'Martin',
    'Lee',
    'Perez',
    'Thompson',
    'White',
    'Harris',
    'Sanchez',
    'Clark',
    'Ramirez',
    'Lewis',
    'Robinson',
  ];

  const companies = [
    'Construction Co',
    'Builders Inc',
    'Contractors LLC',
    'Industrial Solutions',
    'Safety First',
    'Professional Services',
    'Quality Builders',
    'Elite Contractors',
    'Premier Construction',
    'Advanced Builders',
    'Reliable Contractors',
    'Expert Builders',
    'Superior Construction',
    'Ace Contractors',
    'Top Builders',
    'Best Construction',
    'Prime Contractors',
    'Elite Builders',
    'Super Builders',
    'Pro Contractors',
  ];

  const cities = [
    'New York',
    'Los Angeles',
    'Chicago',
    'Houston',
    'Phoenix',
    'Philadelphia',
    'San Antonio',
    'San Diego',
    'Dallas',
    'San Jose',
    'Austin',
    'Jacksonville',
    'Fort Worth',
    'Columbus',
    'Charlotte',
    'San Francisco',
    'Indianapolis',
    'Seattle',
    'Denver',
    'Washington',
    'Boston',
    'El Paso',
    'Nashville',
    'Detroit',
  ];

  const states = [
    'NY',
    'CA',
    'IL',
    'TX',
    'AZ',
    'PA',
    'TX',
    'CA',
    'TX',
    'CA',
    'TX',
    'FL',
    'TX',
    'OH',
    'NC',
    'CA',
    'IN',
    'WA',
    'CO',
    'DC',
    'MA',
    'TX',
    'TN',
    'MI',
  ];

  const customerTypes = ['business', 'individual'];
  const statuses = ['active', 'inactive', 'pending'];
  const communicationTypes = ['email', 'phone', 'sms'];

  for (let i = 0; i < 45; i++) {
    const firstName = firstNames[Math.floor(Math.random() * firstNames.length)];
    const lastName = lastNames[Math.floor(Math.random() * lastNames.length)];
    const company =
      Math.random() > 0.3
        ? companies[Math.floor(Math.random() * companies.length)]
        : null;
    const city = cities[Math.floor(Math.random() * cities.length)];
    const state = states[Math.floor(Math.random() * states.length)];
    const customerType =
      customerTypes[Math.floor(Math.random() * customerTypes.length)];
    const status = statuses[Math.floor(Math.random() * statuses.length)];
    const totalOrders = Math.floor(Math.random() * 20) + 1;
    const totalSpent = Math.round((Math.random() * 5000 + 100) * 100) / 100;

    additionalCustomers.push({
      id: id++,
      firstName,
      lastName,
      email: `${firstName.toLowerCase()}.${lastName.toLowerCase()}@${
        company ? company.toLowerCase().replace(/\s+/g, '') : 'email'
      }.com`,
      phone: `+1 (555) ${Math.floor(Math.random() * 900) + 100}-${
        Math.floor(Math.random() * 9000) + 1000
      }`,
      company,
      address: {
        street: `${Math.floor(Math.random() * 9999) + 1} ${
          ['Main', 'Oak', 'Pine', 'Elm', 'Maple', 'Cedar', 'Birch', 'Willow'][
            Math.floor(Math.random() * 8)
          ]
        } ${
          ['Street', 'Avenue', 'Drive', 'Road', 'Lane', 'Boulevard'][
            Math.floor(Math.random() * 6)
          ]
        }`,
        city,
        state,
        zipCode: `${Math.floor(Math.random() * 90000) + 10000}`,
        country: 'USA',
      },
      status,
      customerType,
      registrationDate: new Date(
        Date.now() - Math.random() * 90 * 24 * 60 * 60 * 1000
      ).toISOString(),
      lastOrderDate:
        status === 'active'
          ? new Date(
              Date.now() - Math.random() * 30 * 24 * 60 * 60 * 1000
            ).toISOString()
          : null,
      totalOrders,
      totalSpent,
      notes: `${
        customerType === 'business'
          ? 'Business customer'
          : 'Individual customer'
      }, ${status === 'active' ? 'regular orders' : 'inactive'}`,
      tags: [
        customerType,
        status === 'active' ? 'regular' : 'inactive',
        company ? 'business' : 'individual',
      ],
      preferences: {
        communication:
          communicationTypes[
            Math.floor(Math.random() * communicationTypes.length)
          ],
        currency: 'USD',
        language: 'en',
      },
    });
  }

  return additionalCustomers;
};

// Combine original customers with generated ones
const allCustomers = [...mockCustomers, ...generateAdditionalCustomers()];

// Simulate API delay
const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

// GET /api/customers - List customers with pagination, search, filters
export const fetchCustomers = async (params = new URLSearchParams()) => {
  if (USE_REAL_API) {
    const url = new URL(`${API_BASE_URL}/admin/customers`);
    for (const [k, v] of params.entries()) url.searchParams.set(k, v);
    const res = await fetch(url.toString(), { headers: { ...authHeaders() } });
    const json = await res.json();
    if (!res.ok) throw new Error(json?.message || 'Failed to fetch customers');
    const customers = json?.data?.customers || json?.data || [];
    const pagination = json?.pagination || {
      page: Number(params.get('page') || 1),
      limit: Number(params.get('limit') || 10),
      total: Array.isArray(customers) ? customers.length : 0,
      totalPages: 1,
    };
    return { customers, pagination };
  }
  await delay(500);
  let filteredCustomers = [...allCustomers];
  const search = params.get('search');
  if (search) {
    filteredCustomers = filteredCustomers.filter(
      (customer) =>
        customer.firstName.toLowerCase().includes(search.toLowerCase()) ||
        customer.lastName.toLowerCase().includes(search.toLowerCase()) ||
        customer.email.toLowerCase().includes(search.toLowerCase()) ||
        (customer.company &&
          customer.company.toLowerCase().includes(search.toLowerCase())) ||
        customer.phone.includes(search)
    );
  }
  const status = params.get('status');
  if (status) {
    filteredCustomers = filteredCustomers.filter(
      (customer) => customer.status.toLowerCase() === status.toLowerCase()
    );
  }
  const customerType = params.get('customerType');
  if (customerType) {
    filteredCustomers = filteredCustomers.filter(
      (customer) =>
        customer.customerType.toLowerCase() === customerType.toLowerCase()
    );
  }
  const sortBy = params.get('sortBy') || 'firstName';
  const sortOrder = params.get('sortOrder') || 'asc';
  filteredCustomers.sort((a, b) => {
    let aValue = a[sortBy];
    let bValue = b[sortBy];
    if (sortBy === 'address.city') {
      aValue = a.address.city;
      bValue = b.address.city;
    }
    if (typeof aValue === 'string') {
      aValue = aValue.toLowerCase();
      bValue = bValue.toLowerCase();
    }
    if (sortOrder === 'asc')
      return aValue < bValue ? -1 : aValue > bValue ? 1 : 0;
    return aValue > bValue ? -1 : aValue < bValue ? 1 : 0;
  });
  const page = parseInt(params.get('page')) || 1;
  const limit = parseInt(params.get('limit')) || 10;
  const startIndex = (page - 1) * limit;
  const endIndex = startIndex + limit;
  const paginatedCustomers = filteredCustomers.slice(startIndex, endIndex);
  return {
    customers: paginatedCustomers,
    pagination: {
      page,
      limit,
      total: filteredCustomers.length,
      totalPages: Math.ceil(filteredCustomers.length / limit),
    },
  };
};

// GET /api/customers/:id - Get single customer
export const fetchCustomer = async (id) => {
  if (USE_REAL_API) {
    const res = await fetch(
      `${API_BASE_URL}/admin/customers/${encodeURIComponent(id)}`,
      { headers: { ...authHeaders() } }
    );
    const json = await res.json();
    if (!res.ok) throw new Error(json?.message || 'Failed to fetch customer');
    return json.data;
  }
  await delay(300);
  const customer = allCustomers.find((c) => c.id === parseInt(id));
  if (!customer) throw new Error('Customer not found');
  return customer;
};

// POST /api/customers - Create customer
export const createCustomer = async (customerData) => {
  if (USE_REAL_API) {
    const res = await fetch(`${API_BASE_URL}/admin/customers`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...authHeaders() },
      body: JSON.stringify(customerData),
    });
    const json = await res.json();
    if (!res.ok) throw new Error(json?.message || 'Failed to create customer');
    return json.data;
  }
  await delay(800);
  const newCustomer = {
    id: allCustomers.length + 1,
    ...customerData,
    registrationDate: new Date().toISOString(),
    totalOrders: 0,
    totalSpent: 0,
    lastOrderDate: null,
  };
  allCustomers.push(newCustomer);
  return newCustomer;
};

// PUT /api/customers/:id - Update customer
export const updateCustomer = async (id, customerData) => {
  if (USE_REAL_API) {
    const res = await fetch(
      `${API_BASE_URL}/admin/customers/${encodeURIComponent(id)}`,
      {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', ...authHeaders() },
        body: JSON.stringify(customerData),
      }
    );
    const json = await res.json();
    if (!res.ok) throw new Error(json?.message || 'Failed to update customer');
    return json.data;
  }
  await delay(800);
  const index = allCustomers.findIndex((c) => c.id === parseInt(id));
  if (index === -1) throw new Error('Customer not found');
  allCustomers[index] = { ...allCustomers[index], ...customerData };
  return allCustomers[index];
};

// DELETE /api/customers/:id - Delete customer
export const deleteCustomer = async (id) => {
  if (USE_REAL_API) {
    const res = await fetch(
      `${API_BASE_URL}/admin/customers/${encodeURIComponent(id)}`,
      { method: 'DELETE', headers: { ...authHeaders() } }
    );
    const json = await res.json();
    if (!res.ok) throw new Error(json?.message || 'Failed to delete customer');
    return json.data || { success: true };
  }
  await delay(500);
  const index = allCustomers.findIndex((c) => c.id === parseInt(id));
  if (index === -1) throw new Error('Customer not found');
  allCustomers.splice(index, 1);
  return { success: true };
};

// Get customer statuses for filters
export const fetchCustomerStatuses = async () => {
  await delay(200);
  return ['active', 'inactive', 'pending'];
};

// Get customer types for filters
export const fetchCustomerTypes = async () => {
  await delay(200);
  return ['business', 'individual'];
};

// Get customer statistics
export const fetchCustomerStats = async () => {
  if (USE_REAL_API) {
    const res = await fetch(`${API_BASE_URL}/admin/customers/stats/summary`, {
      headers: { ...authHeaders() },
    });
    const json = await res.json();
    if (!res.ok)
      throw new Error(json?.message || 'Failed to fetch customer stats');
    return json.data;
  }
  await delay(300);
  const totalCustomers = allCustomers.length;
  const thisMonth = new Date();
  thisMonth.setDate(1);
  const newThisMonth = allCustomers.filter(
    (customer) => new Date(customer.registrationDate) >= thisMonth
  ).length;
  return { totalCustomers, newThisMonth };
};
